import styled from 'styled-components';

import LocalizedLink from '@/components/LocalizedLink/LocalizedLink';

interface LogoProps {
	logo: string;
}

const Logo = ({ logo }: LogoProps) => (
	<LogoRow>
		<LocalizedLink href="/">
			<Image src={logo} alt="Rakuten Viber Logo" />

			<Project>for business</Project>
		</LocalizedLink>
	</LogoRow>
);

const LogoRow = styled.div`
	a {
		display: flex;
		align-items: center;
		font-family: var(--font-sans);

		font-size: 14px;
		line-height: 20px;
		color: var(--color-purple-50);
		text-decoration: none;

		@media (max-width: 1035px) {
			flex-direction: column;
		}
	}
`;

const Image = styled.img`
	display: block;
	margin-right: 10px;
`;

const Project = styled.div`
	width: 85px;

	@media (max-width: 1035px) {
		width: 100%;
	}

	@media (max-width: 600px) {
		display: block;
		width: 100%;
	}
`;

export default Logo;
